import { useState } from 'react';

export type UseViewMoreListParams<T> = {
  list: T[];
  initialViewAmount: number;
  viewMoreAmount: number;
};

export function useViewMoreList<T>(props: UseViewMoreListParams<T>) {
  const [ viewAmount, setViewAmount ] = useState(props.initialViewAmount ?? 10);

  const onViewMoreHandler = () => setViewAmount(p => p + props.viewMoreAmount);
  const onViewLessHandler = () => setViewAmount(p => p - props.viewMoreAmount);

  const viewableList = props.list.slice(0, viewAmount);

  const listLength = props.list.length;
  const viewMoreDisabled = listLength <= viewAmount;
  const viewLessDisabled = viewAmount <= props.initialViewAmount;

  return {
    viewableList,
    onViewMore: onViewMoreHandler,
    onViewLess: onViewLessHandler,
    viewMoreDisabled,
    viewLessDisabled
  };
}
